import React, { useState } from "react";
import FeedContainer from "./SocialFeed";
import ExploreFeed from "./ExploreContent";
import { UsersIcon, SparklesIcon, PlusIcon } from "@heroicons/react/20/solid";

const DropdownButton: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => setIsOpen(!isOpen);

  return (
    <div className="relative inline-block text-left">
      <button
        className="flex items-center justify-center h-[30px] px-4 w-8 bg-indigo-800 text-white rounded-full hover:bg-indigo-700 transition-all duration-300 ease-in-out"
        onClick={toggleDropdown}
      >
        <i className="fas fa-bars"></i>
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg z-10">
          <ul className="py-1 px-2">
            {[
              { icon: "fa-regular fa-trophy", text: "Most Popular" },
              { icon: "fa-regular fa-fire", text: "Trending" },
              { icon: "fa-solid fa-person-walking-luggage", text: "For Me" },
              { icon: "fa-solid fa-heart", text: "Liked" },
            ].map((item, index) => (
              <li
                key={index}
                className="px-2 py-2 text-sm text-gray-700 hover:bg-indigo-100 hover:text-indigo-800 cursor-pointer transition ease-in-out duration-500 rounded-md flex flex-row space-x-2 items-center"
              >
                <i className={item.icon}></i>
                <p>{item.text}</p>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

const SocialHeader: React.FC = () => {
  const [activeButton, setActiveButton] = useState<"feed" | "explore">("feed");

  const buttons = [
    { key: "feed", icon: <UsersIcon className="w-4 h-4" />, text: "My Feed" },
    {
      key: "explore",
      icon: <SparklesIcon className="w-4 h-4" />,
      text: "Explore",
    },
  ] as const;

  return (
    <div className="flex flex-col h-full w-full">
      <div className="flex flex-row w-full justify-between items-center min-h-16">
        <div className="flex flex-row space-x-2">
          {buttons.map((button) => (
            <button
              key={button.key}
              className={`flex flex-row items-center space-x-2 px-3 py-2 text-sm font-medium rounded-full transition ease-in-out duration-300 ${
                activeButton === button.key
                  ? "bg-indigo-800 text-white"
                  : "bg-indigo-50 text-indigo-600 hover:bg-indigo-200 hover:text-indigo-800 hover:shadow-sm"
              }`}
              onClick={() => setActiveButton(button.key)}
            >
              {button.icon}
              <p>{button.text}</p>
            </button>
          ))}
        </div>
      </div>
      <div className="flex items-start justify-center w-full rounded-lg overflow-y-auto no-scrollbar h-[calc(100vh-130px)]">
        {activeButton === "feed" && <FeedContainer />}
        {activeButton === "explore" && <ExploreFeed />}
      </div>
    </div>
  );
};

export default SocialHeader;
